// extracted by mini-css-extract-plugin
export default {"root":"WiseAddToShoppingListButton_root__Gf0in","trigger":"WiseAddToShoppingListButton_trigger__0Hc8L"};